function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/*
  - renderSuggestion
  - fetchSuggestion
  - selectSuggestion
  - normalizeSuggestion (optional)
  - normalizeInput (optional)
  - suggestions
  - total (optional)
  - name
  - error
  - required (optional)
  - disabled (optional)
  - label (optional)
  - placeholder (optional)
  - footer: { component, value } (optional)
  - turnOnClickOutListener: (optional, defaults to true)
*/

import { useRef, useState } from 'react';
import Label from './Label';
import { apricot } from '../../profile';
import { numberFormat } from '../../numeral';
import styles from '../../../sass/forms.module.scss';
export default (function (props) {
  var fetchSuggestions = props.fetchSuggestions,
    renderSuggestion = props.renderSuggestion,
    selectSuggestion = props.selectSuggestion,
    normalizeSuggestion = props.normalizeSuggestion,
    normalizeInput = props.normalizeInput,
    footer = props.footer,
    error = props.error,
    label = props.label,
    arialabel = props.arialabel,
    _props$formGroupStyle = props.formGroupStyles,
    formGroupStyles = _props$formGroupStyle === void 0 ? {} : _props$formGroupStyle,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    name = props.name,
    _onBlur = props.onBlur,
    _onChange = props.onChange,
    placeholder = props.placeholder,
    required = props.required,
    value = props.value,
    disabled = props.disabled,
    _props$turnOnClickOut = props.turnOnClickOutListener,
    turnOnClickOutListener = _props$turnOnClickOut === void 0 ? true : _props$turnOnClickOut,
    _props$minCharacterSe = props.minCharacterSearchLength,
    minCharacterSearchLength = _props$minCharacterSe === void 0 ? 2 : _props$minCharacterSe,
    _props$suggestionIdPr = props.suggestionIdPrefix,
    suggestionIdPrefix = _props$suggestionIdPr === void 0 ? 'autosuggest-option' : _props$suggestionIdPr;
  var _ref = footer || {},
    _ref$alwaysVisible = _ref.alwaysVisible,
    footerAlwaysVisible = _ref$alwaysVisible === void 0 ? false : _ref$alwaysVisible;
  var _apricot$utils$keys = apricot().utils.keys,
    DOWN = _apricot$utils$keys.DOWN,
    UP = _apricot$utils$keys.UP,
    ENTER = _apricot$utils$keys.ENTER,
    TAB = _apricot$utils$keys.TAB,
    ESC = _apricot$utils$keys.ESC;
  var _useState = useState(footerAlwaysVisible),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    changeOpenStatus = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    suggestions = _useState4[0],
    setSuggestions = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    total = _useState6[0],
    setTotal = _useState6[1];
  var containerRef = useRef(null);
  var inputRef = useRef(null);
  var accessibleId = "autosuggest-".concat(name);
  var accessibleDirectionsId = "".concat(accessibleId, "-directions");
  var errId = error ? "errMessage-".concat(name) : null;
  var footerId = footer ? "".concat(suggestionIdPrefix, "-").concat(suggestions.length) : '';
  function reset() {
    setOpen(false);
    setSuggestions([]);
    setTotal(0);
  }
  function select(s) {
    selectSuggestion(normalizeSuggestion ? normalizeSuggestion(s) : s);
    reset();
    inputRef.current.focus();
  }
  function setOpen(newOpenValue) {
    changeOpenStatus(newOpenValue || footerAlwaysVisible);
  }
  function fetch(_x) {
    return _fetch.apply(this, arguments);
  }
  function _fetch() {
    _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
      var _yield$fetchSuggestio, suggestions, total;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchSuggestions(value);
          case 2:
            _yield$fetchSuggestio = _context.sent;
            suggestions = _yield$fetchSuggestio.suggestions;
            total = _yield$fetchSuggestio.total;
            setOpen(Boolean(total));
            setSuggestions(suggestions);
            setTotal(total);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetch.apply(this, arguments);
  }
  function closeAutosuggestionOnClickOut(e) {
    var _ref2 = containerRef || {},
      elem = _ref2.current;
    var focusedOnMenu = elem && elem.contains(e.target);
    if (!focusedOnMenu && isOpen) reset();
  }
  function blurEvent(e) {
    if (e.keyCode === TAB || e.keyCode === ESC) reset();
    if (e.keyCode === ESC) inputRef.current.focus();
  }
  function suggestionKeyDown(e, s) {
    var index = parseInt(e.target.dataset.index, 10);
    e.preventDefault(e);
    blurEvent(e);
    if (e.keyCode === ENTER && s) {
      e.preventDefault();
      select(s, e);
    } else if (e.keyCode === DOWN && (footer && index < suggestions.length || index < suggestions.length - 1)) {
      document.getElementById("".concat(suggestionIdPrefix, "-").concat(index + 1)).focus();
    } else if (e.keyCode === UP && index > 0) {
      var elem = document.getElementById("".concat(suggestionIdPrefix, "-").concat(index - 1));
      if (elem) elem.focus();else inputRef.current.focus();
    } else if (e.keyCode === DOWN && (footer && index === suggestions.length || index === suggestions.length - 1) || e.keyCode === UP && index === 0) {
      inputRef.current.focus();
    }
  }
  useEffect(function () {
    if (turnOnClickOutListener) {
      document.addEventListener('click', closeAutosuggestionOnClickOut);
      return function () {
        return document.removeEventListener('click', closeAutosuggestionOnClickOut);
      };
    }
  }, []);

  // Suggestions added in index 0-9
  // Footer, if provided, added at index suggestion.length
  function renderSuggestions() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['autosuggest-list'],
      style: {
        display: "".concat(isOpen ? 'block' : 'none')
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only",
      id: accessibleDirectionsId
    }, "Use up and down arrows to select"), total ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles['autosuggest-item'], " ").concat(styles['autosuggest-total'])
    }, "Found ", numberFormat(total), " results. Keep typing to narrow the results.") : null, /*#__PURE__*/React.createElement("ul", {
      role: "listbox",
      id: accessibleId
    }, suggestions.map(function (s, i) {
      var id = "".concat(suggestionIdPrefix, "-").concat(i);
      return /*#__PURE__*/React.createElement("li", {
        role: "presentation",
        key: id
      }, /*#__PURE__*/React.createElement("button", {
        role: "option",
        type: "button",
        className: styles['autosuggest-item'],
        id: id,
        "data-index": i,
        onClick: function onClick() {
          return select(s);
        },
        onKeyDown: function onKeyDown(e) {
          return suggestionKeyDown(e, s);
        }
      }, renderSuggestion(s)));
    }), footer ? /*#__PURE__*/React.createElement("li", {
      role: "presentation",
      key: footerId
    }, /*#__PURE__*/React.createElement(footer.component, {
      role: "option",
      className: "".concat(styles['autosuggest-item'], " ").concat(styles['autosuggest-footer']),
      id: footerId,
      "data-index": suggestions.length,
      onKeyDown: function onKeyDown(e) {
        return suggestionKeyDown(e, footer.value);
      },
      onClick: function onClick() {
        return footer.value ? select(footer.value) : null;
      }
    })) : null));
  }
  function renderInput() {
    var val = value || '';
    return /*#__PURE__*/React.createElement("div", {
      className: "cb-input-state ".concat(styles['input-wrapper'])
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: name,
      id: name,
      value: normalizeInput ? normalizeInput(val) : val,
      placeholder: placeholder,
      required: required,
      disabled: disabled,
      ref: inputRef,
      onChange: function onChange(e) {
        if (e.target.value.length > minCharacterSearchLength) fetch(e.target.value);else reset();
        if (_onChange) _onChange(e);
      },
      onBlur: function onBlur(e) {
        e.preventDefault();
        if (_onBlur) _onBlur(e);
      },
      onFocus: function onFocus(e) {
        return e.target.select();
      },
      onKeyDown: function onKeyDown(e) {
        blurEvent(e);
        if (e.keyCode === DOWN && isOpen) {
          var id = suggestions.length ? "".concat(suggestionIdPrefix, "-0") : footer ? footerId : null;
          e.preventDefault();
          if (id) document.getElementById(id).focus();
        }
        // User should not be able to simply enter text and hit enter to submit.
        // The user must select an item from the returned suggestions and
        // proceed through the form from there.
        if (e.keyCode === ENTER) {
          e.preventDefault();
        }
      },
      autoComplete: "off",
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-owns": accessibleId,
      "aria-expanded": isOpen,
      "aria-labelledby": name,
      "aria-label": arialabel || label || placeholder,
      "aria-describedby": error ? errId : accessibleDirectionsId,
      "aria-controls": accessibleId,
      "aria-autocomplete": "list",
      "aria-required": required,
      className: "form-control"
    }), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-search",
      "aria-hidden": true
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(styles['autosuggest-wrapper'], " ").concat(error && !isOpen ? 'has-error' : '', "  ").concat(disabled ? 'disabled' : '', " ").concat(className),
    style: formGroupStyles,
    ref: containerRef
  }, label ? /*#__PURE__*/React.createElement(Label, {
    id: name,
    required: required,
    label: label
  }) : null, renderInput(), renderSuggestions(), error && !isOpen ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert",
    "aria-live": "polite"
  }, error) : null);
});